import { render, staticRenderFns } from "./InputMethodInfo.vue?vue&type=template&id=12c4a116&scoped=true&"
import script from "./InputMethodInfo.vue?vue&type=script&lang=js&"
export * from "./InputMethodInfo.vue?vue&type=script&lang=js&"
import style0 from "./InputMethodInfo.vue?vue&type=style&index=0&id=12c4a116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c4a116",
  null
  
)

export default component.exports